window.mainProductEventsModule = (() => {
  // Private function to handle image click events
  function handleImageClick() {
    const images = document.querySelectorAll('.images_list_container img');
    const imagesContainers = document.querySelectorAll('.img_product_item');

    images.forEach((img) => {
      img.addEventListener('click', () => {
        imagesContainers.forEach((container) => {
          container.classList.remove('active');
        });
        const previewImg = document.querySelector('.preview_img img');
        img.closest('.img_product_item').classList.add('active');
        previewImg.removeAttribute('srcset');
        previewImg.src = img.src;
      });
    });
  }

  // Private function to handle dropdown description product events
  function handleDropdownDescriptionProduct() {
    const dropDownTabs = document.querySelectorAll('.dropdown_tab');
    const dropDownDescriptions = document.querySelectorAll('.description_text');

    dropDownTabs.forEach((dropDownTab, index) => {
      // Find the tab title container within the current dropDownTab
      const tabTitleContainer = dropDownTab.querySelector('.tab_title_container');

      if (tabTitleContainer) {
        // Add event listener to the tab title container only
        tabTitleContainer.addEventListener('click', (event) => {
          event.stopPropagation(); // Ensure only this element triggers the toggle

          // Toggle active state for the clicked tab
          dropDownTab.classList.toggle('active_dropdow_tab');

          // Show/Hide corresponding description
          const description = dropDownDescriptions[index];
          if (description.style.display === 'block') {
            description.style.display = 'none';
          } else {
            description.style.display = 'block';
          }
        });
      }
    });
  }

  // Private function to update content based on variant change (desktop and mobile)
  // Private function to update content based on variant change (desktop and mobile)
  function updateContent(variantId) {
    // Hide all variant info tables
    document.querySelectorAll('.variant-info-table').forEach((table) => {
      table.style.display = 'none'; 
    });
    document.querySelectorAll('.variant-info-table-mobile').forEach((table) => {
      table.style.display = 'none';
    });

    const zutatenNaehrwerteContentId = `variant-${variantId}-zutaten_naehrwerte`;
    const selectedZutatenNaehrwerteContent = document.getElementById(zutatenNaehrwerteContentId);
    if (selectedZutatenNaehrwerteContent) {
      selectedZutatenNaehrwerteContent.style.display = 'flex';
    }
    // Mobile content
    const mobileZutatenNaehrwerteContent = document.querySelector(
      ".dropdown_tab[data-content='zutaten_naehrwerte'] .description_text"
    );

    if (mobileZutatenNaehrwerteContent) {
      mobileZutatenNaehrwerteContent.querySelectorAll('.variant-info-table-mobile').forEach((table) => {
        table.style.display = 'none';
      });
    }

    // Show the relevant mobile content

    const mobileZutatenNaehrwerte = document.getElementById(`${zutatenNaehrwerteContentId}-mobile`);
    if (mobileZutatenNaehrwerte) {
      mobileZutatenNaehrwerte.style.display = 'block';
      if (mobileZutatenNaehrwerteContent) {
        mobileZutatenNaehrwerteContent.innerHTML = mobileZutatenNaehrwerte.innerHTML;
        mobileZutatenNaehrwerteContent.style.display = 'block';
      }
    } else if (mobileZutatenNaehrwerteContent) {
      mobileZutatenNaehrwerteContent.style.display = 'none';
    }
  }

  // Private function to get the variant ID from the URL
  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  // Private function to get the current variant ID
  function getCurrentVariantId() {
    const variantIdElement = document.querySelector('input[name="id"]');
    return variantIdElement ? variantIdElement.value : null;
  }

  // Private function to handle tab switching logic
  function handleTabs() {
    const tabs = document.querySelectorAll('.tab_choice_item');
    const descriptions = document.querySelectorAll('.description');

    // Initialize the tabs and descriptions
    if (tabs.length > 0) {
      // Set the first tab as active and show its corresponding description
      tabs[0].classList.add('active_tab');
      const firstTabContent = document.querySelector(`.description[data-content="${tabs[0].dataset.tab}"]`);
      if (firstTabContent) {
        firstTabContent.style.display = 'block';
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          // Remove active class from all tabs
          tabs.forEach((t) => t.classList.remove('active_tab'));
          // Hide all descriptions
          descriptions.forEach((desc) => (desc.style.display = 'none'));

          // Add active class to the clicked tab
          this.classList.add('active_tab');

          // Show the corresponding description
          const contentToShow = document.querySelector(`.description[data-content="${this.dataset.tab}"]`);
          if (contentToShow) {
            contentToShow.style.display = 'block';
          }
        });
      });
    }
  }

  // Initialization function
  function init() {
    // Initialize image click events
    handleImageClick();

    // Initialize dropdown description product events
    handleDropdownDescriptionProduct();

    // Initialize content display based on variant ID
    const variantId = getVariantIdFromUrl() || getCurrentVariantId();
    if (variantId) {
      updateContent(variantId);
    }

    // Handle variant change events
    document.querySelectorAll('[name="id"]').forEach((variantSelector) => {
      variantSelector.addEventListener('change', function () {
        updateContent(this.value);
      });
    });

    // Initialize tabs
    handleTabs();
  }

  // Auto-initialize when the script is loaded
  init();

  // Public API
  return {
    init,
  };
})();
